/*eslint no-debugger:0 */
import userStore from 'stores/userStore';
import { warn, } from 'application/console';
import { BaseStore, } from 'stores/baseStore';
import punditActions from 'actions/punditActions';
import networkProvider from 'providers/networkProvider';
import { queryString, hash, navigateTo } from 'utils/window';
import { t, i18n, } from 'providers/i18nProvider/i18nProvider';
import { getCountryCode, } from 'providers/geolocationProvider';
import safeLocalStorage from 'providers/safeLocalStorageProvider';
import vbetsServiceProvider from 'providers/vbetsService/vbetsServiceProvider';
import actionCounterProviderActions from 'actions/actionCounterProviderActions';
import {
  sendData as sendDataToCurrentActionCounterProvider,
  fetchMatchVbetDistribution,
} from 'providers/actionCounter/currentPostActionCounterProvider';
import { punditData, isHybrid, pageLocale, pageDomain, postId, isDraft } from 'application/pageDataObject';


const { homeTeam, awayTeam, bettingProviderData, matchId, } = punditData;
const { punditShowSelectionWidget, debugPundit, } = queryString;

const CAPTIONS = [homeTeam, t('pundit.draw'), awayTeam, ];

const PUNDIT_CONFIG = {
  NO_SELECTION: -1,
  //Action Counter
  ACTION_COUNTER_VBET_URL: 'vbet',
  ACTION_COUNTER_VOTE_PARAM: 'bet_on',
  ACTION_COUNTER_MATCH_ID_PARAM: 'match',
  ACTION_COUNTER_VBET_DATA_KEY: `MatchVbetsDistribution_${ matchId }`,
  //Vbets service
  VBET_SERVICE_URL: 'vbets',
  VBETS_SERVICE_MATCH_ID_PARAM: 'match_id',
  VBETS_SERVICE_VOTE_PARAM: 'prediction',
  VBETS_SERVICE_DOMAIN_PARAM: 'domain',
  //graph related
  SHOW_VBET_GRAPH_STORAGE_KEY: `pundit_vbet_show_graph_${ matchId }`,
  //hybrid related
  HYBRID_VOTE_URL: 'http://app.90min.interaction.vote.',
  HYBRID_LOGIN_URL: 'http://app.90min.interaction.login',
};

const SELECTIONS = ["1", "x", "2"];

class PunditStore extends BaseStore {

  constructor(options){
    super(options);
    this
      .merge({
        matchStarted: false,
        showExternalBettingProvider: false,
        vBetData: [],
        externalBettingProvider: {
          link: '',
          logo: '',
        },
      })
      .formatDateTime()
      .getLatestVbetData()
      .fetchTopPredictors()
      // For debugging purposes;
      .showVbet = punditShowSelectionWidget ? false : this.loadVbetUserVoteFromStorage();
  }

  routeAction(action){
    const ACTIONS = punditActions.TYPES;
    const ACTION_COUNTER_ACTIONS = actionCounterProviderActions.TYPES;
    switch (action.type) {
      case ACTIONS.VOTE:
        return this.vote(action.punditVbetObject, action.hybridRedirect);
      case ACTIONS.HYBRID_LOGIN:
        return navigateTo(PUNDIT_CONFIG.HYBRID_LOGIN_URL);
      default:
        return this;
    }
  }

  vote(selection, hybridRedirect, simulateVoteWithoutRegistering){
    this.selection = SELECTIONS.indexOf(selection.toString());
    this.showVbet = true;
    this.vBetData[this.selection] = (+this.vBetData[this.selection] + 1).toString();
    this.emitChange();
    this.registerVoteInTheSystem(selection, hybridRedirect, simulateVoteWithoutRegistering);
  }

  formatDateTime(){
    this.matchDateTime = new Date(punditData.matchTime);
    if (new Date().getTime() > this.matchDateTime.getTime()) {
      this.matchStarted = true;
    }
    this.matchDateTime = i18n.localize("time.formats.date_format", this.matchDateTime);
    return this;
  }

  getLatestVbetData(){
    fetchMatchVbetDistribution()
      .then(this.onActionCounterDataReceived.bind(this))
      .catch(warn);
    return this;
  }

  onActionCounterDataReceived(data){
    const mockVbetData = queryString.punditVbetData;
    const { selection } = this;
    const retrievedData = mockVbetData ? JSON.parse(mockVbetData) : data;
    if (retrievedData){
      const { 1: acHomeTeam = 0, x: draw = 0, 2: acAwayTeam = 0, } = retrievedData;
      this.vBetData = [acHomeTeam, draw, acAwayTeam, ];
      if (isHybrid) {
        if (hash.vote) {
          this.vote(hash.vote);
        }
      } else if (retrievedData.error !== undefined && selection > PUNDIT_CONFIG.NO_SELECTION) {
        const simulateVoteWithoutRegistering = true;
        this.vote(selection, isHybrid, simulateVoteWithoutRegistering);
      }
    }
    this.emitChange();
  }

  loadVbetUserVoteFromStorage(){
    let showVbet = false;
    try {
      this.selection = isHybrid ? hash.vote : SELECTIONS.indexOf(safeLocalStorage.get(PUNDIT_CONFIG.SHOW_VBET_GRAPH_STORAGE_KEY, '').toString());
      showVbet = this.selection > PUNDIT_CONFIG.NO_SELECTION || false;
    } catch (ex) {
      debugPundit && warn('failed loading/parsing vbet flag from localStorage', ex);
    }
    return showVbet || this.matchStarted;
  }

  registerVoteInTheSystem(selection, hybridRedirect, simulateVoteWithoutRegistering){
    try {
      if (isHybrid) {
        if (hybridRedirect && !simulateVoteWithoutRegistering) {
          navigateTo(`${ PUNDIT_CONFIG.HYBRID_VOTE_URL }${ selection }`);
        }
      } else if (!simulateVoteWithoutRegistering) {
        if (userStore.state.id) {
          vbetsServiceProvider.report(`${ PUNDIT_CONFIG.VBET_SERVICE_URL }/${ pageLocale }/${ userStore.state.id }`, {
            [PUNDIT_CONFIG.VBETS_SERVICE_MATCH_ID_PARAM]: matchId,
            [PUNDIT_CONFIG.VBETS_SERVICE_VOTE_PARAM]: selection,
            [PUNDIT_CONFIG.VBETS_SERVICE_DOMAIN_PARAM]: pageDomain,
          });
        }
        sendDataToCurrentActionCounterProvider(`${ PUNDIT_CONFIG.ACTION_COUNTER_VBET_URL }`, {
          [PUNDIT_CONFIG.ACTION_COUNTER_MATCH_ID_PARAM]: matchId,
          [PUNDIT_CONFIG.ACTION_COUNTER_VOTE_PARAM]: selection,
        });
        safeLocalStorage.set(PUNDIT_CONFIG.SHOW_VBET_GRAPH_STORAGE_KEY, selection);
      }
    } catch (ex) {
      debugPundit && warn('failed saving vbet flag to localStorage', ex);
    }
  }
  get matchDateTime(){ return this._matchDateTime; }
  set matchDateTime(datetime){ this._matchDateTime = datetime; }
  get matchStarted(){ return this._matchStarted; }
  set matchStarted(bool){ this._matchStarted = bool; }
  get captions(){ return CAPTIONS; }
  get selection(){ return this._selection; }
  set selection(index){ this._selection = index; }
  get vBetData(){return this._vBetData; }
  set vBetData(obj){ this._vBetData = obj; }
  get showVbet(){ return this._showVbet; }
  set showVbet(bool){ this._showVbet = bool; }
  get externalBettingProvider(){ return this._externalBettingProvider; }
  set externalBettingProvider(obj){ this._externalBettingProvider = obj; }
  get showExternalBettingProvider(){ return this._showExternalBettingProvider; }
  set showExternalBettingProvider(bool){ this._showExternalBettingProvider = bool; }

  setExternalBettingProvider(countryCode){
    const { link, logo, } = this.parseResultsByCountryCode(countryCode);
    this.externalBettingProvider = { link, logo, };
    return this.emitChange();
  }

  hideExternalBettingProvider(ex){
    this.showExternalBettingProvider = false;
    return this.emitChange();
  }

  fetchExternalBettingProvider(){
    getCountryCode()
      .then(this.setExternalBettingProvider.bind(this))
      .catch(this.hideExternalBettingProvider.bind(this));
    return this;
  }

  fetchTopPredictors(){
    if (!isDraft) {
      networkProvider
        .safeRequest({
          method: 'GET',
          url: `/singlepage/pipe?r[TopPredictors][v]=1&r[TopPredictors][post_id]=${ postId }`,
          type: 'json',
        })
        .then(this.setTopPredictors.bind(this))
        .catch(warn);
    }
    return this;
  }

  setTopPredictors(TopPredictorsPredenter){
    this.externalTopPredictors = TopPredictorsPredenter.TopPredictors.top_predictors;
    this.emitChange();
    this.fetchExternalBettingProvider();
    return this;
  }

  parseResultsByCountryCode(ccode){
    const possiblyOverridenCcode = queryString.ccode || ccode;
    const ccBettingData = bettingProviderData[possiblyOverridenCcode.toLowerCase()];
    const providers = ccBettingData ? ccBettingData[0] : false;
    if (providers) {
      this.showExternalBettingProvider = true;
    }
    return providers;
  }

}


const punditStore = PunditStore.create();

export default {
  PunditStore,
  punditStore,
};


// WEBPACK FOOTER //
// ./provolution/app/views/provolution/jsCore/organizedByType/stores/punditStore.js